export function StatusPill({ status, "data-testid": dataTestid }) {
  const map = {
    in_use: { label: "In Use", cls: "text-[#2D7A4F] bg-[rgba(45,122,79,0.1)] border-[rgba(45,122,79,0.3)]" },
    storage: { label: "Storage", cls: "text-[#3A3A3A] bg-[#E8E3D6] border-[#D6CFC1]" },
    repair: { label: "Repair", cls: "text-[#B45309] bg-[rgba(180,83,9,0.1)] border-[rgba(180,83,9,0.3)]" },
    retired: { label: "Retired", cls: "text-[#B91C1C] bg-[rgba(185,28,28,0.1)] border-[rgba(185,28,28,0.3)]" },
  };
  const v = map[status] || map.in_use;
  return (
    <span
      data-testid={dataTestid}
      className={`inline-flex items-center font-mono text-[10px] tracking-[0.18em] uppercase px-2 py-0.5 border ${v.cls}`}
    >
      {v.label}
    </span>
  );
}
